import React from 'react';
import './CommunityGuidelines.css';

function CommunityGuidelines({ onClose }) {
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content guidelines-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>×</button>

        <h1>Community Guidelines</h1>

        <div className="guidelines-section">
          <h2>Our Mission</h2>
          <p>
            This platform provides a safe space for biological women to discuss gender critical perspectives,
            sex-based rights, and concerns about gender ideology without fear of censorship or harassment.
          </p>
        </div>

        <div className="guidelines-section">
          <h2>Core Principles</h2>
          <ul>
            <li><strong>Respect for Women:</strong> This is a women-only space. We prioritize the voices and experiences of biological women.</li>
            <li><strong>Good Faith Discussion:</strong> Engage thoughtfully and assume good intent from other members.</li>
            <li><strong>Evidence-Based:</strong> Support claims with facts, research, and credible sources when possible.</li>
            <li><strong>Privacy & Safety:</strong> Protect the anonymity and safety of all community members.</li>
          </ul>
        </div>

        <div className="guidelines-section">
          <h2>Prohibited Content</h2>

          <h3>Absolutely Forbidden:</h3>
          <ul>
            <li><strong>Doxxing:</strong> Never share personal identifying information about any individual, including real names, addresses, phone numbers, workplaces, or photos without explicit consent.</li>
            <li><strong>Threats or Violence:</strong> No threats of violence, encouraging self-harm, or promoting illegal activity.</li>
            <li><strong>Harassment:</strong> No targeted harassment, stalking, or coordinated attacks against individuals.</li>
            <li><strong>Spam:</strong> No advertising, self-promotion, or repetitive off-topic content.</li>
            <li><strong>Hate Speech:</strong> No content promoting violence or discrimination based on race, ethnicity, religion, disability, or sexual orientation.</li>
          </ul>

          <h3>Strongly Discouraged:</h3>
          <ul>
            <li>Personal attacks or ad hominem arguments</li>
            <li>Derailing productive discussions</li>
            <li>Bad faith engagement or trolling</li>
            <li>Sharing unverified rumors or misinformation</li>
            <li>Excessive negativity or doom-posting</li>
          </ul>
        </div>

        <div className="guidelines-section">
          <h2>Posting Guidelines</h2>

          <h3>What to Post:</h3>
          <ul>
            <li>News and analysis related to gender ideology, women's rights, and sex-based protections</li>
            <li>Personal experiences and perspectives from a gender critical viewpoint</li>
            <li>Resources, studies, and educational materials</li>
            <li>Questions and requests for support or advice</li>
            <li>Discussions about activism, organizing, and political action</li>
          </ul>

          <h3>Content Quality:</h3>
          <ul>
            <li>Use descriptive titles that accurately reflect your post content</li>
            <li>Provide context and sources when sharing news or claims</li>
            <li>Be clear about whether content is opinion, analysis, or factual reporting</li>
            <li>Use content warnings for sensitive topics (violence, trauma, etc.)</li>
          </ul>
        </div>

        <div className="guidelines-section">
          <h2>Comment Guidelines</h2>
          <ul>
            <li><strong>Stay on Topic:</strong> Keep comments relevant to the post and discussion</li>
            <li><strong>Be Constructive:</strong> If you disagree, explain why respectfully</li>
            <li><strong>Avoid Pile-Ons:</strong> Don't gang up on individual users</li>
            <li><strong>Use Upvotes:</strong> Upvote quality contributions rather than just agreement</li>
            <li><strong>Report Issues:</strong> Use the report function for rule violations rather than engaging</li>
          </ul>
        </div>

        <div className="guidelines-section">
          <h2>Privacy & Security</h2>
          <ul>
            <li><strong>Protect Your Identity:</strong> Never share identifying details about yourself</li>
            <li><strong>Use Unique Credentials:</strong> Use a unique password not used elsewhere</li>
            <li><strong>Be Cautious with Links:</strong> Don't click suspicious links; verify sources</li>
            <li><strong>Screenshots:</strong> When sharing screenshots, redact identifying information</li>
            <li><strong>External Sharing:</strong> Be mindful that content posted here may be shared elsewhere</li>
          </ul>
        </div>

        <div className="guidelines-section">
          <h2>Verification & Trust</h2>
          <p>
            Users who request verification gain access to private Discord and WhatsApp groups. Verification
            requires demonstrating you are a biological woman through a confidential process with administrators.
          </p>
          <ul>
            <li>Verified users receive a checkmark badge</li>
            <li>Verification is optional but required for private group access</li>
            <li>All verification details are kept strictly confidential</li>
            <li>Administrators will never share verification information</li>
          </ul>
        </div>

        <div className="guidelines-section">
          <h2>Moderation</h2>

          <h3>Content Moderation:</h3>
          <ul>
            <li>Posts and comments may be removed if they violate these guidelines</li>
            <li>Repeated violations may result in account suspension or ban</li>
            <li>Moderators will provide warnings when appropriate</li>
            <li>Serious violations (doxxing, threats) result in immediate removal</li>
          </ul>

          <h3>Reporting:</h3>
          <ul>
            <li>Report content that violates guidelines using the report button</li>
            <li>Reports are reviewed by moderators within 24-48 hours</li>
            <li>False reporting or report abuse may result in penalties</li>
            <li>For urgent safety concerns, contact administrators directly</li>
          </ul>

          <h3>Appeals:</h3>
          <ul>
            <li>If content is removed, you may contact moderators for clarification</li>
            <li>Account suspensions may be appealed via email</li>
            <li>Decisions on serious violations are final</li>
          </ul>
        </div>

        <div className="guidelines-section">
          <h2>Legal Considerations</h2>
          <ul>
            <li>Users are responsible for the content they post</li>
            <li>Content must comply with applicable laws</li>
            <li>The platform reserves the right to cooperate with law enforcement</li>
            <li>Illegal content will be reported to appropriate authorities</li>
          </ul>
        </div>

        <div className="guidelines-section">
          <h2>Changes to Guidelines</h2>
          <p>
            These guidelines may be updated periodically. Continued use of the platform constitutes
            acceptance of any changes. Major changes will be announced to the community.
          </p>
        </div>

        <div className="guidelines-footer">
          <p>
            <strong>Questions?</strong> Contact the moderation team via the site contact form.
          </p>
          <p>
            Last updated: December 11, 2025
          </p>
        </div>
      </div>
    </div>
  );
}

export default CommunityGuidelines;
